<template>
    <PageWrapper 
        name="campus-resources"
        navTitle="Tools And Resources To Further Enable Your Success"
        navTitleId="tools-resource-title"
        routeName="resource"
        :items="resources"
        :backButton="{
            route: backButton.backRoute,
            label: backButton.backLabel,
        }"
    >

        <template v-slot:body>
            <router-view :key="$route.path" />
        </template>

    </PageWrapper>
</template>

<script>
import { gsap } from 'gsap'

import PageWrapper from '../PageWrapper'
import innerBackButton from '@/mixins/lib/innerBackButton'
import { focusOrderWatcher } from '@/mixins/focusOrder'

export default {
    name: 'CampusResources',
    metaInfo: {
        title: 'Campus Resources'
    },

    components: {
        PageWrapper,
    },

    mixins: [
        focusOrderWatcher,
    ],

    created() {
        this.$store.dispatch('fetchCampusEventsData').then(() => {
            this.rootClass('rm')
        })
    },

    beforeRouteUpdate( to, from, next ) {
        gsap.to( document.body, {
            scrollTop: 0,
            duration: .75,
            ease: 'expo',
            onComplete: next
        })
    },

    computed: {
        resources() {
            return this.$store.getters.campusResources
        },
        backButton() {
            const { path } = this.$route
            
            const parentRoute = {
                path: 'campus-resources',
                label: 'Back to Campus Resources'
            }

            return innerBackButton( path, parentRoute )
        }
    },
}
</script>
